import { render, staticRenderFns } from "./TeacherTypeList.vue?vue&type=template&id=47310a87"
import script from "../../controllers/teacher_type/teacher-type-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/teacher_type/teacher-type-list.js?vue&type=script&lang=js&external"
import style0 from "./TeacherTypeList.vue?vue&type=style&index=0&id=47310a87&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports